<template>
  <div id="contenedor-eliminar-licitacion-participante">
      <v-card>
          <v-card-title class="secondary--text">
              ¿Desea eliminar al Responsable?
          </v-card-title>
          <v-card-text>
            <span
              class="secondary--text">
              {{ responsableContratoEliminar.funcionario.nombre }}
            </span>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixEliminarContratoResponsable"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
  </div>
</template>

<script>
import mixResponsableContrato from './mixResponsableContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarResponsableContrato',
  mixins: [mixResponsableContrato],
  props: {
    responsableContratoEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
